/* @sravni/react-design-system version 0.2.65 */
import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import modules_3717c142 from '../styles/Link.module.less.js';

/**
 * @description The Link component is used for anchor links. This component renders a a element by default
 *
 * @component
 * @example
 * ```jsx
 * <Link href="#">Link</Link>
 * ```
 */
var Link = React.forwardRef(function (props, ref) {
    var _a;
    var color = props.color, strong = props.strong, className = props.className, children = props.children, restProps = __rest(props, ["color", "strong", "className", "children"]);
    var cx = useStyles(modules_3717c142);
    var classNames = cx(className, 'container', (_a = {},
        _a["color-" + color] = color,
        _a.strong = strong,
        _a));
    return (React.createElement("a", __assign({ ref: ref, className: classNames }, restProps), children));
});
Link.defaultProps = {
    color: 'blue',
};
Link.displayName = 'Link';

export { Link };
//# sourceMappingURL=Link.js.map
